<template>
  <svg viewBox="0 0 18 13" xmlns="http://www.w3.org/2000/svg">
    <g fill="#424256" fill-rule="nonzero" stroke="#424256" stroke-width=".1">
      <path d="M17.708 5.842c-.144-.232-3.6-5.684-8.62-5.684S.612 5.61.468 5.842c-.238.38-.238.86 0 1.241.144.232 3.6 5.665 8.616 5.68h.024c5.004 0 8.46-5.451 8.604-5.684.235-.38.234-.858-.004-1.237zm-8.6 5.74c-4.4 0-7.6-5.121-7.6-5.121s3.2-5.122 7.6-5.122c4.4 0 7.6 5.122 7.6 5.122s-3.212 5.12-7.6 5.12z"/>
      <path d="M9.088 3.31c-1.767 0-3.2 1.41-3.2 3.15 0 1.741 1.433 3.152 3.2 3.152 1.767 0 3.2-1.41 3.2-3.151 0-1.74-1.433-3.152-3.2-3.152zm0 5.12c-1.105 0-2-.882-2-1.97 0-1.087.895-1.97 2-1.97s2 .883 2 1.97c0 1.088-.895 1.97-2 1.97z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ic-private'
}
</script>
